export default class AuthUser {
    public apiKey: string;
    public userId: string;
    public companyId: string;
    public jwt: string;
    public refreshJwt: string;
    public authToken: string
    public refreshToken: string

    constructor(params: { [key: string]: any }) {
        this.apiKey = params.apiKey;
        this.userId = params.userId;
        this.companyId = params.companyId;
        this.jwt = params.jwt;
        this.refreshJwt = params.refreshJwt;
        this.authToken = params.authToken
        this.refreshToken = params.refreshToken
    }
}

export interface IAuthToken {
    channel?:            string;
    source?:             string;
    sourceId?:           string;
    authClass?:          string;
    authClassId?:        string;
    primaryAuthClassId?: string;
    iat?:                number;
    exp?:                number;
    appMeta?: {
      supportAgentId?: string
    }
}